const RouteData = [
    {
        path: '/Home',
        name: 'home',
        meta: {
            title: '工作台',
            show: true,
        },
        routeName: 'home',
        checked: true,
        child: true,
        isOpen: true,
        icon: 'el-icon-s-home',
        children: [{
            path: '/Home',
            name: 'home',
            meta: {
                title: '工作台',
                requiresAuth: true,
                basicName: 'home',
                basic: '工作台',
                model: 'home',
            },
            child: false,
            component: () =>
                import(
                    '../views/Home.vue'
                ),
        }]
    },
    // {
    //     path: '/userAccount/buy',
    //     name: 'buy',
    //     icon: 'el-icon-ali-chongzhi',
    //     isOpen: true,
    //     target:'_blank',
    //     meta: {
    //         title: '时间戳充值',
    //         show: true,
    //         child: false,
    //         isparent: true,
    //     },
    // },
    {
        path: '/userAccount',
        name: 'userAccount',
        meta: {
            title: '账户管理',
            icon: 'el-icon-s-custom',
            show: true,
        },
        routeName: 'account',
        checked: true,
        child: true,
        icon: 'el-icon-s-custom',
        isOpen: true,
        children: [{
            path: '/userAccount/overview',
            name: 'userAccountOverParents',
            meta: {
                title: '账户总览',
                basic: '账户管理',
                fullPath: '/userAccount/overview',
                basicName: 'userAccount',
                model: 'userAccountOver',
            },
            component: () =>
                import('../components/Middleware'),
            children: [{
                path: '/userAccount/overview',
                name: 'userAccountOver',
                meta: {
                    title: '账户总览',
                    basic: '账户管理',
                    model: 'userAccountOver',
                    fullPath: '/userAccount/overview',
                    basicName: 'userAccount',
                },
                component: () =>
                    import('../views/userAccount/overview.vue'),
            },
            {
                path: '/userAccount/overview/expire',
                name: 'Expire',
                meta: {
                    title: '账户总览',
                    requiresAuth: true,
                    basicName: 'userAccount',
                    basic: '账户管理',
                    fullPath: '/userAccount/overview',
                    secondPath: '/userAccount/overview',
                    secondTitle: '即将过期',
                    model: 'userAccountOver',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Individual" */
                        '../views/userAccount/expire.vue'
                    ),
            },
            ],
        },
        {
            path: '/userAccount/buy',
            name: 'userAccountBuyParents',
            meta: {
                isparent: true,
                title: '立即购买',
                basic: '账户管理',
                basicName: 'userAccount',
                fullPath: '/userAccount/buy',
                model: 'userAccountBuy',
            },
            component: () =>
                import('../components/Middleware'),
            children: [{
                path: '/userAccount/buy',
                name: 'userAccountBuy',
                meta: {
                    title: '立即购买',
                    basic: '账户管理',
                    basicName: 'userAccount',
                    model: 'userAccountbuy',
                    fullPath: '/userAccount/overview',
                },
                component: () =>
                    import('../views/userAccount/buy.vue'),
            },
            // {
            //     path: '/userAccount/buy1',
            //     name: 'userAccountBuy',
            //     meta: {
            //         title: '立即购买',
            //         basic: '账户管理',
            //         basicName: 'userAccount',
            //         model: 'userAccountbuy',
            //         fullPath: '/userAccount/overview',
            //     },
            //     component: () =>
            //         import('../views/userAccount/buy1.vue'),
            // },
            {
                path: '/userAccount/buy/rules',
                name: 'Rules',
                meta: {
                    title: '立即购买',
                    requiresAuth: true,
                    basicName: 'userAccount',
                    basic: '账户管理',
                    fullPath: '/userAccount/overview',
                    secondPath: '/userAccount/buy',
                    secondTitle: '计费规则',
                    model: 'userAccountOver',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "rules" */
                        '../views/userAccount/rules.vue'
                    ),
            },
            {
                path: '/userAccount/buy/refundPolicy',
                name: 'RefundPolicy',
                meta: {
                    title: '立即购买',
                    requiresAuth: true,
                    basicName: 'userAccount',
                    basic: '账户管理',
                    fullPath: '/userAccount/overview',
                    secondPath: '/userAccount/buy',
                    secondTitle: '退费规则',
                    model: 'userAccountOver',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "refundPolicy" */
                        '../views/userAccount/refundPolicy.vue'
                    ),
            },
            {
                path: '/userAccount/buy/paySuccess',
                name: 'PaySuccess',
                meta: {
                    title: '立即购买',
                    requiresAuth: true,
                    basicName: 'userAccount',
                    basic: '账户管理',
                    fullPath: '/userAccount/buy',
                    secondPath: '/userAccount/buy',
                    secondTitle: '充值成功',
                    realTitle: '充值成功',
                    model: 'userAccountOver',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Individual" */
                        '../views/userAccount/paySuccess.vue'
                    ),
            },
            ]
        },
        {
            path: '/order/orderList',
            name: 'orderList',
            meta: {
                isparent: true,
                title: '订单列表',
                basic: '账户管理',
                requiresAuth: true,
                basicName: 'userAccount',
                model: 'userAccount',
                fullPath: '/userAccount/overview',
            },

            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/order/orderList.vue'
                ),
        },
        {
            path: '/userAccount/state',
            name: 'userAccountState',
            meta: {
                title: '消费明细',
                basic: '账户管理',
                basicName: 'userAccount',
                fullPath: '/userAccount/overview',
                requiresAuth: true,
                model: 'association',
            },
            child: false,

            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/userAccount/state.vue'
                ),
        },
        {
            path: '/userAccount/coupon',
            name: 'coupon',
            meta: {
                isparent: true,
                title: '我的优惠券',
                basic: '账户管理',
                basicName: 'userAccount',
                fullPath: '/userAccount/overview',
                requiresAuth: true,
                model: 'association',
            },
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/userAccount/coupon.vue'
                ),
        },
        {
            path: '/userAccount/orderVerify',
            name: 'orderVerify',
            meta: {
                isparent: true,
                title: '验证报告订单',
                basic: '账户管理',
                basicName: 'userAccount',
                fullPath: '/userAccount/overview',
                requiresAuth: true,
                model: 'association',
            },
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/userAccount/orderVerify.vue'
                ),
        },
        {
            path: '/userAccount/invoice',
            name: 'userAccountInvoice',
            meta: {
                title: '开发票',
                basic: '账户管理',
                basicName: 'userAccount',
                fullPath: '/invoice/apply',
                requiresAuth: true,
                navTo: '/invoice/apply',
                isparent: true,
            },
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "invoice" */
                    '../views/invoice/apply.vue'
                ),
        },
        {
            path: '/userAccount/wxPay',
            name: 'userAccountWxPay',
            meta: {
                title: '微信支付',
                basic: '账户管理',
                basicName: 'userAccount',
                isWxpay: true,
                model: 'association',
                fullPath: '/userAccount/overview',
            },
            child: false,

            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/userAccount/wxPay.vue'
                ),
        },
        {
            path: '/userAccount/refund',
            name: 'userAccountRefund',
            meta: {
                title: '退款详情',
                basic: '账户管理',
                basicName: 'userAccount',
                isWxpay: true,
                model: 'association',
                fullPath: '/userAccount/overview',
            },
            child: false,

            component: () =>
                import(
                    /* webpackChunkName: "userAccountRefund" */
                    '../views/userAccount/refund.vue'
                ),
        },
        {
            path: '/userAccount/return',
            name: 'userAccountReturn',
            meta: {
                title: '时间戳返还确认',
                basic: '账户管理',
                basicName: 'userAccount',
                isWxpay: true,
                model: 'association',
                fullPath: '/userAccount/overview',
            },
            child: false,

            component: () =>
                import(
                    /* webpackChunkName: "userAccountReturn" */
                    '../views/userAccount/return.vue'
                ),
        },
        ],
    },
    {
        path: '/userCenter',
        name: 'userCenter',
        meta: {
            title: '用户中心',
            icon: 'el-icon-user',
            show: true,
        },
        routeName: 'basic',
        icon: 'el-icon-user-solid',
        isOpen: true,
        children: [{
            path: '/userCenter/userInfo',
            name: 'userInfo',
            meta: {
                title: '基本信息',
                model: 'userInfo',
                basic: '用户中心',
                basicName: 'userCenter',
                fullPath: '/userCenter/userInfo',
            },
            component: () =>
                import('../views/userCenter/userInfo.vue'),
        },
        {
            path: '/userCenter/AuthenticationName',
            name: 'AuthenticationNameParents',
            meta: {
                isparent: true,
                title: '实名认证',
                basic: '用户中心',
                fullPath: '/userCenter/userInfo',
                basicName: 'userCenter',
                model: 'AuthenticationName',
            },
            component: () =>
                import('../components/Middleware'),
            children: [{
                path: '/userCenter/AuthenticationName',
                name: 'AuthenticationName',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    basic: '用户中心',
                    model: 'AuthenticationName',
                    fullPath: '/userCenter/userInfo',
                    basicName: 'userCenter',
                },
                component: () =>
                    import('../views/userCenter/AuthenticationName.vue'),
            },
            {
                path: '/userCenter/AuthenticationName/Individual',
                name: 'Individual',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    secondTitle: '自然人认证方式选择',
                    model: 'AuthenticationName',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Individual" */
                        '../views/userCenter/Individual.vue'
                    ),
            },
            // {
            //     path: '/userCenter/Enterprise',
            //     name: 'Enterprise',
            //     meta: {
            //         isparent: true,
            //         title: '实名认证',
            //         requiresAuth: true,
            //         basicName: 'userCenter',
            //         basic: '用户中心',
            //         fullPath: '/userCenter/userInfo',
            //         secondPath: '/userCenter/AuthenticationName',
            //         secondTitle: '企业认证类型选择',
            //         model: 'AuthenticationName',
            //     },
            //     component: () =>
            //         import (
            //             /* webpackChunkName: "Enterprise" */
            //             '../views/userCenter/Enterprise.vue'
            //         ),
            // },
            {
                path: '/userCenter/Enterbank',
                name: 'Enterbank',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    // thirdPath: '/userCenter/Enterprise',
                    basic: '用户中心',
                    // firstTitle: '企业认证类型选择',
                    secondTitle: '法人认证',

                    model: 'AuthenticationName',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Enterbank" */
                        '../views/userCenter/Enterbank.vue'
                    ),
            },
            {
                path: '/userCenter/Enterapply',
                name: 'Enterapply',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    // thirdPath: '/userCenter/Enterprise',
                    basic: '用户中心',
                    // firstTitle: '企业认证类型选择',
                    secondTitle: '法人认证',

                    model: 'AuthenticationName',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Enterapply" */
                        '../views/userCenter/Enterapply.vue'
                    ),
            },
            {
                path: '/userCenter/Entercheck',
                name: 'Entercheck',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/Enterprise',
                    // firstTitle: '企业认证类型选择',
                    secondTitle: '认证结果',
                    model: 'AuthenticationName',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Entercheck" */
                        '../views/userCenter/Entercheck.vue'
                    ),
            },
            {
                path: '/userCenter/Personbank',
                name: 'Personbank',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/AuthenticationName/Individual',

                    basic: '用户中心',
                    // firstTitle: '个人认证类型选择',
                    secondTitle: '银行卡认证',
                    model: 'AuthenticationName',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Personbank" */
                        '../views/userCenter/Personbank.vue'
                    ),
            },
            {
                path: '/userCenter/Personphone',
                name: 'Personphone',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/AuthenticationName/Individual',
                    // firstTitle: '个人认证类型选择',
                    secondTitle: '手机号认证',
                    model: 'AuthenticationName',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Personphone" */
                        '../views/userCenter/Personphone.vue'
                    ),
            },
            {
                path: '/userCenter/FaceIdent',
                name: 'FaceIdent',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/AuthenticationName/Individual',
                    // firstTitle: '个人认证类型选择',
                    secondTitle: '人脸识别',
                    model: 'AuthenticationName',
                },
                component: () =>
                    import('../views/userCenter/FaceIdent.vue'),
            },
            // ******************新版实名认证************************
            {
                path: '/userCenter/realName/authenticationType',
                name: 'authenticationType',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    basic: '用户中心',
                    model: 'realName',
                    fullPath: '/userCenter/userInfo',
                    basicName: 'userCenter',
                },
                component: () =>
                    import('../views/userCenter/realName/authenticationType.vue'),
            },
            {
                path: '/userCenter/realName/enterpriseIndex',
                name: 'enterpriseIndex',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    firstTitle: '企业实名认证',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/enterpriseIndex.vue'),
            },
            {
                path: '/userCenter/realName/enterpriseInfo',
                name: 'enterpriseInfo',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '企业基础信息认证',
                    //secondTitle: '企业实名认证基本信息',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/enterpriseInfo.vue'),
            },
            {
                path: '/userCenter/realName/enterpriseAuthorize',
                name: 'enterpriseAuthorize',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '认证授权',
                    // secondTitle: '认证授权',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/enterpriseAuthorize.vue'),
            },
            {
                path: '/userCenter/realName/enterpriseApply',
                name: 'enterpriseApply',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '申请信息',
                    // secondTitle: '申请信息',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/enterpriseApply.vue'),
            },
            {
                path: '/userCenter/realName/enterpriseResult',
                name: 'enterpriseResult',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '申请结果',
                    // secondTitle: '申请结果',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/enterpriseResult.vue'),
            },
            {
                path: '/userCenter/realName/enterpriseSign',
                name: 'enterpriseSign',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '知情同意书',
                    // secondTitle: '签署授权书',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/enterpriseSign.vue'),
            },
            {
                path: '/userCenter/realName/enterpriseSuccess',
                name: 'enterpriseSuccess',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '企业实名成功',
                    // secondTitle: '企业实名成功',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/enterpriseSuccess.vue'),
            },
            {
                path: '/userCenter/realName/personalInfo',
                name: 'personalInfo',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '法人基本信息',
                    // secondTitle: '法人基本信息',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/personalInfo.vue'),
            },
            {
                path: '/userCenter/realName/authenticationMode',
                name: 'authenticationMode',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '认证方式',
                    // secondTitle: '认证方式',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/authenticationMode.vue'),
            },
            {
                path: '/userCenter/realName/legalPhone',
                name: 'legalPhone',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '手机号认证',
                    // secondTitle: '手机号认证',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/legalPhone.vue'),
            },
            {
                path: '/userCenter/realName/legalBank',
                name: 'legalBank',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '银行卡认证',
                    // secondTitle: '银行卡认证',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/legalBank.vue'),
            },
            {
                path: '/userCenter/realName/legalFace',
                name: 'legalFace',
                meta: {
                    isparent: true,
                    title: '实名认证',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/AuthenticationName',
                    thirdPath: '/userCenter/realName/enterpriseIndex',
                    firstTitle: '人脸核身',
                    // secondTitle: '人脸核身',
                    model: 'realName',
                },
                component: () =>
                    import('../views/userCenter/realName/legalFace.vue'),
            },
            ],
        },
        {
            path: '/userCenter/lawyer',
            name: 'lawyer',
            meta: {
                isparent: true,
                title: '律师认证',
                basic: '用户中心',
                basicName: 'userCenter',
                fullPath: '/userCenter/userInfo',
                requiresAuth: true,
                model: 'association',
            },
            component: () =>
                import('../views/userCenter/lawyer.vue'),
        },
        {
            path: '/userCenter/association',
            // href: '/user/association',
            name: 'association',
            meta: {
                title: '关联账号',
                basic: '用户中心',
                basicName: 'userCenter',
                fullPath: '/userCenter/userInfo',
                requiresAuth: true,
                model: 'association',
            },
            component: () =>
                import('../components/Middleware'),
                // import(
                //     /* webpackChunkName: "AuthenticationName" */
                //     '../views/userCenter/association.vue'
                // ),
            children: [{
                path: '/userCenter/association',
                name: 'association',
                meta: {
                    title: '关联账号',
                    basic: '用户中心',
                    model: 'association',
                    fullPath: '/userCenter/userInfo',
                    basicName: 'userCenter',
                },
                component: () =>
                    import('../views/userCenter/association.vue'),
            },
            {
                path: '/userCenter/changeBindApply',
                name: 'changeBindApply',
                meta: {
                    isparent: true,
                    title: '关联账号',
                    requiresAuth: true,
                    basicName: 'userCenter',
                    basic: '用户中心',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/association',
                    secondTitle: '申请结果',
                    model: 'association',
                },
                component: () =>
                    import('../views/userCenter/changeBindApply.vue'),
            }]
        },
        {
            path: '/userCenter/security',
            name: 'security',
            meta: {
                title: '安全中心',
                basic: "用户中心",
                requiresAuth: true,
                basicName: 'userCenter',
                model: 'security'
            },
            child: false,
            component: () =>
                import('../components/Middleware'),
            children: [{
                path: '/userCenter/security',
                name: 'security',
                meta: {
                    title: '安全中心',
                    basic: "用户中心",
                    requiresAuth: true,
                    basicName: 'userCenter',
                    fullPath: '/userCenter/userInfo',
                    model: 'security'
                },
                component: () =>
                    import('../views/userCenter/security.vue')
            },
            {
                path: '/userCenter/security/annul',
                name: 'Annul',
                meta: {
                    title: '安全中心',
                    basic: "用户中心",
                    requiresAuth: true,
                    basicName: 'userCenter',
                    fullPath: '/userCenter/userInfo',
                    secondPath: '/userCenter/userInfo/',
                    secondTitle: '账号注销',
                    model: 'security'
                },
                component: () =>
                    import('../views/userCenter/annul.vue')
            },
            {
                path: '/security/logout',
                name: 'securityLogout',
                meta: {
                    title: '安全中心',
                    basic: "用户中心",
                    model: 'security',
                    fullPath: '/userCenter/userInfo',
                    basicName: 'userCenter',
                },
                component: () =>
                    import('../views/userCenter/securityCom/logout')
            },
            ],
        },
        {
            path: '/userCenter/agreeMent',
            name: 'agreeMent',
            meta: {
                isparent: true,
                title: '协议中心',
                basic: '用户中心',
                basicName: 'userCenter',
                fullPath: '/userCenter/userInfo',

                model: 'agreeMent',
            },
            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/userCenter/agreeMent.vue'
                ),
        },
        ],
    },
    // {
    //     path: '/order',
    //     name: 'order',
    //     meta: {
    //         isparent: true,
    //         title: '订单管理',
    //         icon: 'el-icon-s-order',
    //         show: true,
    //     },
    //     routeName: 'order',
    //     checked: true,
    //     child: true,
    //     isOpen: true,
    //     icon: 'el-icon-s-order',
    //     children: [{
    //         path: '/order/orderList',
    //         name: 'orderList',
    //         meta: {
    //             title: '订单列表',
    //             requiresAuth: true,
    //             model: 'userAccount',
    //             basic: '订单管理',
    //             icon: 'el-icon-user',
    //             basicName: 'order',
    //         },
    //         icon: 'el-icon-user-solid',
    //         child: false,
    //         component: () =>
    //             import (
    //                 /* webpackChunkName: "AuthenticationName" */
    //                 '../views/order/orderList.vue'
    //             ),
    //     }, ],
    // },
    {
        path: `${process.env.VUE_APP_PAN}`,
        name: 'pan',
        icon: 'el-icon-ali-zhengjuguanli2',
        isOpen: true,
        target:'_blank',
        meta: {
            title: '证据管理',
        },
    },
    {
        path: `${process.env.VUE_APP_LAWCASE}/userCenter/myConsult`,
        name: 'lawcase',
        icon: 'el-icon-ali-wodeanyuan',
        isOpen: true,
        target:'_blank',
        meta: {
            islawyer: true,
            title: '我的案源',
        },
    },
    {
        path: '/invoice',
        name: 'invoice',
        meta: {
            isparent: true,
            title: '发票管理',
            icon: 'el-icon-ali-fapiao',
            show: true,
        },
        routeName: 'order',
        checked: true,
        child: true,
        isOpen: true,
        icon: 'el-icon-ali-fapiao',
        children: [{
            path: '/invoice/apply',
            name: 'apply',
            meta: {
                title: '申请发票',
                requiresAuth: true,
                model: 'invoice',
                basic: '申请发票',
                icon: 'el-icon-user',
                basicName: 'invoice',
            },
            icon: 'el-icon-user-solid',
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '@view/invoice/Middleware.vue'
                ),

            children: [{
                path: '/invoice/apply',
                name: 'applychild',
                meta: {
                    title: '申请发票',
                    model: 'invoice',
                    basic: '发票管理',
                    basicName: 'invoice',
                    fullPath: '/invoice/apply',
                },
                component: () =>
                    import('@view/invoice/apply.vue'),
            },
            {
                path: '/invoice/personIn',
                name: 'personIn',
                meta: {
                    title: '申请发票',
                    model: 'invoice',
                    basic: '发票管理',
                    basicName: 'invoice',
                    fullPath: '/invoice/apply',
                },
                component: () =>
                    import('@view/invoice/personIn.vue'),
            },
            ],
        },
        {
            path: '/invoice/history',
            name: 'history',
            meta: {
                title: '开票历史',
                requiresAuth: true,
                model: 'invoice',
                basic: '发票管理',
                icon: 'el-icon-user',
                basicName: 'invoice',
                fullPath: '/invoice/apply',
            },
            icon: 'el-icon-user-solid',
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/invoice/history.vue'
                ),
        },
        {
            path: '/invoice/explain',
            name: 'explain',
            meta: {
                title: '开票说明',
                requiresAuth: true,
                model: 'invoice',
                basic: '发票管理',
                icon: 'el-icon-user',
                basicName: 'invoice',
                fullPath: '/invoice/apply',
            },
            icon: 'el-icon-user-solid',
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/invoice/explain.vue'
                ),
        },
        {
            path: '/invoice/invoiceTitle',
            name: 'invoiceTitle',
            meta: {
                title: '发票抬头',
                requiresAuth: true,
                model: 'invoice',
                basic: '发票管理',
                icon: 'el-icon-user',
                basicName: 'invoice',
                fullPath: '/invoice/apply',
            },
            icon: 'el-icon-user-solid',
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "AuthenticationName" */
                    '../views/invoice/invoiceTitle.vue'
                ),
        },
        ],
    },
    // {
    //     path: "/interface",
    //     name: "interface",
    //     meta: {
    //         title: "接口账户管理",
    //         icon: "el-icon-s-marketing",
    //         show: true
    //     },
    //     routeName: "interface",
    //     checked: true,
    //     child: true,
    //     isOpen: false,
    //     icon: 'el-icon-s-marketing',
    //     children: [{
    //             path: '/interface/account',
    //             name: 'interface',
    //             meta: {
    //                 title: '接口账户总览',
    //                 requiresAuth: true,
    //                 model: 'interface',
    //                 basic: "接口账户管理",
    //                 icon: "el-icon-user",
    //                 basicName: 'interface',

    //             },
    //             icon: 'el-icon-user-solid',
    //             child: false,
    //             component: () =>
    //                 import ( /* webpackChunkName: "AuthenticationName" */ '../views/interface/account.vue'),
    //         },
    //         {
    //             path: '/interface/bill',
    //             name: 'bill',
    //             meta: {
    //                 title: '接口消费账单',
    //                 requiresAuth: true,
    //                 model: 'interface',
    //                 basic: "接口账户管理",
    //                 icon: "el-icon-user",
    //                 basicName: 'interface',

    //             },
    //             icon: 'el-icon-user-solid',
    //             child: false,
    //             component: () =>
    //                 import ( /* webpackChunkName: "AuthenticationName" */ '../views/interface/bill.vue'),
    //         },

    //     ]
    // },

    {
        path: '/subAccount',
        name: 'subAccount',
        meta: {
            title: '子账号管理',
            icon: 'el-icon-ali-denglu-yonghuzu',
            show: true,
            isparent: true,
        },
        routeName: 'subAccount',
        checked: true,
        child: true,
        isOpen: true,
        icon: 'el-icon-ali-denglu-yonghuzu',
        children: [{
            path: '/subAccount/subList',
            name: 'subList',
            meta: {
                isparent: true,
                title: '子账号列表',
                requiresAuth: true,
                model: 'subAccount',
                basic: '子账号管理',
                icon: 'el-icon-ali-denglu-yonghuzu',
                basicName: 'subAccount',
            },
            icon: 'el-icon-ali-denglu-yonghuzu',
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "subList" */
                    '../views/subAccount/subList.vue'
                ),
        },
        {
            path: '/subAccount/applyCount',
            name: 'applyCount',
            meta: {
                isparent: true,
                title: '申请统计',
                requiresAuth: true,
                model: 'subAccount',
                basic: '子账号管理',
                icon: 'el-icon-user',
                basicName: 'subAccount',
                fullPath: '/subAccount/subList',
            },
            icon: 'el-icon-user-solid',
            child: false,
            component: () =>
                import(
                    /* webpackChunkName: "applyCount" */
                    '../views/subAccount/applyCount.vue'
                ),
        },
        ],
    },

    {
        path: `${process.env.VUE_APP_GETREWARDS}`,
        name: 'dealer',
        icon: 'el-icon-ali-yaoqingyouli',
        isOpen: true,
        target:'_blank',
        meta: {
            title: '邀请有礼',
        },
    },

    // {
    //     path: '/supportCenter',
    //     name: 'supportCenter',
    //     meta: {
    //         title: '帮助中心',
    //         icon: 'el-icon-s-marketing',
    //         show: true,
    //     },
    //     routeName: 'supportCenter',
    //     checked: true,
    //     child: true,
    //     isOpen: true,
    //     icon: 'el-icon-s-marketing',
    //     children: [{
    //         href: '/wiki.html',
    //         path: '/supportCenter/index',
    //         name: 'supportCenterIndex',
    //         meta: {
    //             title: '帮助中心',
    //             requiresAuth: true,
    //             model: 'supportCenter',
    //             basic: '帮助中心',
    //             icon: 'el-icon-user',
    //             basicName: 'supportCenter',
    //         },
    //         icon: 'el-icon-user-solid',
    //         child: false,
    //         component: () =>
    //             import(
    //                 /* webpackChunkName: "AuthenticationName" */
    //                 '../views/supportCenter'
    //             ),
    //     }],
    // },
    {
        path: '/messageCenter',
        name: 'messageCenter',
        meta: {
            title: '消息中心',
            icon: 'el-icon-message-solid',
            show: true,
        },
        routeName: 'messageCenter',
        checked: true,
        child: true,
        isOpen: true,
        icon: 'el-icon-message-solid',
        children: [
            {
                path: '/messageCenter/history',
                name: 'history',
                meta: {
                    title: '全部消息',
                    requiresAuth: true,
                    basic: '消息中心',
                    basicName: 'messageCenter',
                },
                child: false,
                component: () =>
                    import(
                        /* webpackChunkName: "AuthenticationName" */
                        '../views/message/history'
                    ),
            },
            {
                path: '/messageCenter/setting',
                name: 'setting',
                meta: {
                    title: '消息设置',
                    requiresAuth: true,
                    basic: '消息中心',
                    basicName: 'messageCenter',
                },
                child: false,
                component: () =>
                    import(
                        /* webpackChunkName: "AuthenticationName" */
                        '../views/message/setting'
                    ),
            },
        ],
    },
]
let routeArray = []
RouteData.forEach((item) => {
    if (item.children) routeArray.push(...item.children)
    
})
export { RouteData, routeArray }